import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const role = searchParams.get('role') || 'owner';
  const navigate = useNavigate();

  const [form, setForm] = useState({ new_password: '', confirm_password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  if (!token) {
    return (
      <div className="main-full">
        <div className="auth-container">
          <div className="auth-card">
            <div className="alert alert-error">Invalid or missing reset token.</div>
            <div className="auth-footer"><Link to="/forgot-password">Request a new link</Link></div>
          </div>
        </div>
      </div>
    );
  }

  function handleChange(e) {
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
    setError('');
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (form.new_password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (form.new_password !== form.confirm_password) { setError('Passwords do not match.'); return; }

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: form.new_password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || 'Reset failed.'); return; }
      setDone(true);
      setTimeout(() => navigate(role === 'staff' ? '/staff/login' : '/login'), 2500);
    } catch {
      setError('Network error. Is the backend running?');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="main-full">
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-logo">
            <h1>Roster<span>AI</span></h1>
            <p>Smart restaurant staff scheduling</p>
          </div>

          <h2 className="auth-title">Reset Password</h2>
          <p className="auth-subtitle">Enter your new password</p>

          {done ? (
            <div className="alert alert-success">
              Password reset successfully! Redirecting to login...
            </div>
          ) : (
            <>
              {error && <div className="alert alert-error">{error}</div>}
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>New Password</label>
                  <input
                    type="password"
                    className="form-control"
                    name="new_password"
                    value={form.new_password}
                    onChange={handleChange}
                    placeholder="At least 8 characters"
                    autoComplete="new-password"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Confirm Password</label>
                  <input
                    type="password"
                    className="form-control"
                    name="confirm_password"
                    value={form.confirm_password}
                    onChange={handleChange}
                    placeholder="Repeat new password"
                    autoComplete="new-password"
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary btn-block btn-lg" disabled={loading}>
                  {loading ? <span className="spinner" /> : 'Reset Password'}
                </button>
              </form>
            </>
          )}

          <div className="auth-footer">
            <Link to="/login">Back to Login</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
